import React from "react";
import { Card } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { CreateLoanApi, LoanLicenseType } from "../../../../../services/Api/types";

interface Props {
	form: UseFormReturn<CreateLoanApi>;
}

const NewLoanPreviewTypeCard = ({ form }: Props) => {
	const { t } = useTranslation("admin");
	const {
		formState: { errors },
		clearErrors,
		control,
	} = form;

	const licenseOptions = [
		{
			label: "Basic",
			value: LoanLicenseType.BASIC,
		},
		{
			label: "Pro",
			value: LoanLicenseType.PRO,
		},
	];

	return (
		<Card className={"mb-3"}>
			<Card.Body>
				<h5>{t("modules.loan.field.choose_loan_type.title")}</h5>
				<FormSelectGroup
					onChange={() => clearErrors("license_level")}
					errors={errors}
					name="license_level"
					options={licenseOptions}
					defaultValue="BASIC"
					control={control}
					label={t("modules.loan.field.loan_type.title")}
					data-testid="license_level"
				/>
			</Card.Body>
		</Card>
	);
};

export default NewLoanPreviewTypeCard;
